const DJ_TOKEN_PREFIX = "wu.djToken.";

/** Reads the stored DJ session token for a site, if any. */
export function getDjToken(siteId: string): string | null {
  try {
    return window.localStorage.getItem(DJ_TOKEN_PREFIX + siteId);
  } catch {
    return null;
  }
}

/** Persists the DJ session token (a short-lived signed token) for a site. */
export function setDjToken(siteId: string, token: string): void {
  try {
    window.localStorage.setItem(DJ_TOKEN_PREFIX + siteId, token);
  } catch {
    // Ignore storage failures (private mode); the DJ re-enters the PIN.
  }
}

/** Clears the stored DJ session token for a site. */
export function clearDjToken(siteId: string): void {
  try {
    window.localStorage.removeItem(DJ_TOKEN_PREFIX + siteId);
  } catch {
    // Ignore storage failures.
  }
}
